/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Chains multiple callbacks together with a break condition.
 * If a callback returns true, the execution of remaining callbacks is stopped.
 *
 * @param callbacks - The callbacks to chain together.
 * @returns A function that executes each callback in order, stopping if a callback returns true.
 */

function chainWithBreakCondition() {
  for (var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++) {
    callbacks[_key] = arguments[_key];
  }
  return function () {
    for (var _i = 0, _callbacks = callbacks; _i < _callbacks.length; _i++) {
      var callback = _callbacks[_i];
      if (typeof callback === 'function') {
        var shouldBreak = callback.apply(void 0, arguments);
        if (shouldBreak) break;
      }
    }
  };
}

export { chainWithBreakCondition };
//# sourceMappingURL=chain-with-break-condition.esm.js.map
